import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getRequestInfo , resetUser } from "../actions/inquires";
import { errorOpen } from "../actions/step";

import { appointementInit } from "../actions/appointement";

import { RequestPurchase } from "./components/RequestPurchase";
import { RequestInformation } from "./components/RequestInformation";

import BooleanButton from "./components/BooleanButton";

const dataUser = {
  wlName: "seat",
  locale: "fr",
  webProjectName: "YokayHTML",
  withCustomerValues: false,
  origin: "api_erdv"
};

const unactiveBtnStyle = {
  borderColor: "#f4bca4",
  color:"#f4bca4",
  background: "#fff",
  cursor: "default"
};


class ClassRequest extends Component {
  constructor(props) {
    super(props);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleCheckChange(value, name) {
    this.props.getRequestInfo(this.props.inquires.home.type, value, name);
  }
  handleRangeChange = (index, label, name) => {
    var value = { index: index, label: label };
    this.props.getRequestInfo(this.props.inquires.home.type, value, name);
  };
  handleSubmit(event) {
    event.preventDefault();

    //TRACKING
    var values = {};
    var type = this.props.inquires.home.type;
    if(this.props.inquires.home.type=="achat") {
      this.props.inquires.achat.test=="non" ? values.eventName = "purchaseprojectno" : values.eventName = "purchaseprojectyes";
      this.props.inquires[type]['purchaseTime']['leadName']===undefined ? values['purchaseIntent'] = "Less than a month" : values['purchaseIntent'] = this.props.inquires[type]['purchaseTime']['leadName'];
      values['financinge'] = this.props.inquires[type]['financing'];
      values['seatCustomer'] = this.props.inquires[type]['customerSeat'];
      values['licenseRegistration'] = "";
    } else if(this.props.inquires.home.type=="demande") {
      values.eventName = "information-request";
    }
    this.props.inquires[type]['appointment']==null ? values['prefence'] = "" : values['prefence'] = this.props.inquires[type]['appointment'];
    this.props.inquires[type]['test']=="non" || this.props.inquires[type]['test']==null ? values['testDrive'] = "non" : values['testDrive'] = "oui";
    var iframeData = ["setData", values];
    console.log(iframeData);
    window.top.postMessage(iframeData , '*');

    if(this.props.inquires.achat.plate!=""){
      var regOldPlate = /^[aA-zZ]{2}?\d{3}?[aA-zZ]{2}$/;
      var regNewPlate = /^\d{3}?[aA-zZ]{3}?\d{2}$/;
      var errorMsg = [];
      if(!regOldPlate.test(this.props.inquires.achat.plate) && !regNewPlate.test(this.props.inquires.achat.plate)){
        errorMsg.push("L'immatriculation' " + this.props.inquires.achat.plate + " est invalide.\n");
        const errmsg = errorMsg.map( e => {
          return (<span>{e}<br/></span>);
        })
        this.props.errorOpen('Message d\'erreur', errmsg);
      } else {
          this.props.resetUser();
          this.props.appointementInit("CustomerCardFieldList", dataUser, "user");
      }
    } else {
      this.props.resetUser();
      this.props.appointementInit("CustomerCardFieldList", dataUser, "user");
    }


  }
  componentDidMount(){
    var iframeData = ['setVirtualPage', 'rdv-en-ligne/purchase_project'];
    console.log('iframeData :'+ iframeData );
    window.top.postMessage(iframeData , '*');
  }
  render() {
    var formValidate = false;
    if(this.props.inquires.home.type === 'demande'){
        if(this.props.inquires.demande.appointment === 'telephone' || ( this.props.inquires.demande.appointment === 'concession' && this.props.inquires.demande.test !== null)){
          formValidate = true;
        }
    }else{
      if(this.props.inquires.achat.test === 'oui' || ( this.props.inquires.achat.test === 'non' && this.props.inquires.achat.appointment !== null)){
        if(this.props.inquires.achat.financing !== null &&  this.props.inquires.achat.customerSeat !== null){
            formValidate = true;
        }
      }
    }
    return (
      <div className="moduleMainBodyIntel">
        <form onSubmit={this.handleSubmit} className="unselectable">
          {this.props.inquires.home.type === "achat" ? (
            <RequestPurchase />
          ) : null}
          {this.props.inquires.home.type === "demande" ? (
            <RequestInformation />
          ) : null}
          <div className="pageCtaContent">
            <div className="pageMention fontBook colorGrey3">
              *Champs obligatoires
            </div>
            <button
              className="pageCta fontMedium colorBlack"
              disabled={!formValidate}
              style={formValidate ? null : unactiveBtnStyle}
            >
              Continuer
            </button>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ...state
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getRequestInfo,
      appointementInit,
      resetUser,
      errorOpen
    },
    dispatch
  );

export const PageRequest = connect(
  mapStateToProps,
  mapDispatchToProps
)(ClassRequest);



// WEBPACK FOOTER //
// ./src/containers/PageRequest.js